var _path, _path2, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEthernetVpnEvpn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46973,38.53369l4,3.99707,1.06054-1.06152-2.71875-2.71631H17.25V52.82861c0,4.93409,2.918,9.61573,7.09766,11.38477L39.709,70.69092a.74869.74869,0,0,0,.583,0l15.30469-6.47754v-.00049c4.17773-1.76855,7.0957-6.44971,7.0957-11.38428V38.73438h5.502L65.46875,41.4707l1.0625,1.0586,4-4.01563a.74973.74973,0,0,0-.00195-1.06055l-4-3.98437-1.0586,1.0625,2.71387,2.70313H62.69238V14a.75019.75019,0,0,0-.75-.75H18a.7502.7502,0,0,0-.75.75V37.25293H11.80957l2.7207-2.72266-1.06054-1.06054-4,4.00293a.7503.7503,0,0,0,0,1.061ZM18.75,14.75H61.19238V52.82861c0,4.28028-2.59863,8.48731-6.17968,10.00342L39.999,69.186,24.93066,62.832C21.34961,61.31543,18.75,57.1084,18.75,52.82861Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30,46.75h3.25V50a.7502.7502,0,0,0,.75.75h3.25V52a.7502.7502,0,0,0,.75.75h4a.7502.7502,0,0,0,.75-.75V50.75H46a.7502.7502,0,0,0,.75-.75V46.75H50a.7502.7502,0,0,0,.75-.75V28a.7502.7502,0,0,0-.75-.75H30a.7502.7502,0,0,0-.75.75V46A.7502.7502,0,0,0,30,46.75Zm.75-18h18.5v16.5H46a.7502.7502,0,0,0-.75.75v3.25H42a.7502.7502,0,0,0-.75.75v1.25h-2.5V50a.7502.7502,0,0,0-.75-.75H34.75V46a.7502.7502,0,0,0-.75-.75H30.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.25,
    y: 32,
    width: 1.5,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.25,
    y: 32,
    width: 1.5,
    height: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.25,
    y: 32,
    width: 1.5,
    height: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45.25,
    y: 32,
    width: 1.5,
    height: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEthernetVpnEvpn);
export default __webpack_public_path__ + "static/media/icon_ethernet_vpn_evpn.59e5cd1ed671f849dbaf2e20a4fe64f5.svg";
export { ForwardRef as ReactComponent };